import * as React from 'react';
import { SVGProps } from 'react';

const SvgMask = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M13.013 31.3v-4.7a10.405 10.405 0 0 1-4.73-3.066 10.377 10.377 0 0 1-1.85-10.68A10.386 10.386 0 0 1 9.856 8.38a10.414 10.414 0 0 1 15.017 2.72 10.37 10.37 0 0 1 1.63 5.389l2.126 5.865a1.171 1.171 0 0 1-1.107 1.573h-1.351v.8a4.422 4.422 0 0 1-1.09 2.924 4.437 4.437 0 0 1-2.752 1.48v2.17"
    />
    <path
      fill={props.fill}
      d="M27.273 35.625h-15.11v-4.316h10.78l4.33 4.316Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M25.41 15.306v.001c-4.19 4.521-3.22 10.639-2.568 13.193l2.568-13.194Zm0 0 .097-.104h1.451a3.09 3.09 0 0 1 2.949 2.15l.635 1.977a7.718 7.718 0 0 1-5.114 9.752l-1.023.31a1.267 1.267 0 0 1-.351.055m1.356-14.14-1.356 14.14m2.903-14.994H25.18l-.32.345c-4.47 4.825-3.404 11.299-2.744 13.888a2 2 0 0 0 .712 1.088l4.13-15.321Zm0 0a3.84 3.84 0 0 1 3.664 2.671l-3.664-2.671Zm-2.903 14.994a1.256 1.256 0 0 1-1.212-.946l1.212.946Z"
    />
    <path
      fill="currentColor"
      d="m31.105 27.998-2.554-2.554-2.554 2.554 2.554 2.554 2.554-2.554Z"
    />
    <path
      fill="currentColor"
      d="M32.529 31.659a4.284 4.284 0 0 1-3.051-1.265l-1.666-1.657 1.527-1.528 1.666 1.666a2.158 2.158 0 0 0 3.021 0l1.528 1.524a4.285 4.285 0 0 1-3.025 1.26Z"
    />
    <path stroke="currentColor" strokeWidth={1.5} d="m6 14 16.224 7.553" />
  </svg>
);

export default SvgMask;
